import React, { useEffect } from 'react';
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Col, Tabs } from 'antd';
import { FullHeightRow, StyledTabs } from '../../components';
import { ConsentTab } from '../../types/enums/consentType.enum';
import { GivenConsentsComponent } from './GivenConsents/GivenConsentsComponent';
import { loadGivenConsents } from '../../store/actions/carriers';

const ConsentsContentHolder = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadGivenConsents(false));
  }, [dispatch]);

  return (
    <>
      <BreadcrumbsItem to={`/consents/${ConsentTab.GIVEN_CONSENTS}`}>
        {t('BREADCRUMB.MY_GIVEN_CONSENTS')}
      </BreadcrumbsItem>
      <StyledTabs
        defaultActiveKey={ConsentTab.GIVEN_CONSENTS}
        activeKey={ConsentTab.GIVEN_CONSENTS}
        size="small"
      >
        <Tabs.TabPane
          tab={t('BREADCRUMB.MY_GIVEN_CONSENTS')}
          key={ConsentTab.GIVEN_CONSENTS}
        >
          <FullHeightRow gutter={[10, 10]} style={{ paddingTop: '10px' }}>
            <Col span={24}>
              <GivenConsentsComponent />
            </Col>
          </FullHeightRow>
        </Tabs.TabPane>
      </StyledTabs>
    </>
  );
};

export default ConsentsContentHolder;
